<ion-fab-button [color]="themeColor" (click)="onButtonClicked()">
  <ion-icon [name]="icon"></ion-icon>
</ion-fab-button>
